import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// Libary
import i18n from "@/core/plugins/vue-i18n";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "element-plus/theme-chalk/display.css";

import * as ElementPlusIconsVue from "@element-plus/icons-vue";

import { Vue3Lottie } from "vue3-lottie";

// Style
import "@/assets/style/style.scss";

import createLoadingPlugin from "./core/plugins/loading";

const app = createApp(App);
app.use(router);
app.use(store);
app.use(ElementPlus);

app.use(i18n);

// Install the loading plugin
app.use(createLoadingPlugin());
app.component("Vue3Lottie", Vue3Lottie);

declare global {
  interface Number {
    priceFormat(): string;
  }
}

// Implement the function on Number prototype
Number.prototype.priceFormat = function (): string {
  return Number(this)
    .toFixed(2)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

app.mount("#app");
